import { backendService } from "../../../core/backend/services/backendService";

class ClinicsService {
  public clinicsList() {
    return backendService.createBackendClient().apiClinicsList();
  }
}

export const clinicsService = new ClinicsService();
